import request from '@/utils/request';

/**
 * 角色权限
 */

// 获取企业所有角色
export function getAllRoleApi(params) {
  return request({
    url: '/enterprise-server/enterprises/' + params.eid + '/roles',
    method: 'GET',
    params: params
  });
}

// 获取所有权限
export function getAllPermissionsApi(params) {
  return request({
    url: '/enterprise-server/enterprises/' + params.eid + '/permissions',
    method: 'GET',
    params: params
  });
}

// 获取角色的所有权限
export function getPermissionsByRoleApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/roles/' +
      params.roleID +
      '/perms',
    method: 'GET',
    params: params
  });
}

// 添加角色
export function addNewRoleApi(params) {
  return request({
    url: '/enterprise-server/enterprises/' + params.eid + '/roles',
    method: 'POST',
    data: params
  });
}

// 删除角色
export function delteRoleApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/roles/' +
      params.roleID,
    method: 'DELETE',
    params: params
  });
}

// 修改角色名称
export function modifyRoleApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/roles/' +
      params.roleID,
    method: 'PUT',
    data: params
  });
}

// 修改角色权限
export function modifyRolePermissionApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/roles/' +
      params.roleID +
      '/perms',
    method: 'PUT',
    data: params
  });
}

// 获取企业某个角色下的员工
export function getUserFormRoleApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/roles/' +
      params.roleID +
      '/users',
    method: 'GET',
    params: params
  });
}

// 从角色中删除
export function deleteUserFormRoleApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/roles/' +
      params.roleID +
      '/users/' +
      params.userID,
    method: 'DELETE',
    data: params
  });
}

export function addUserToRoleApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/roles/' +
      params.roleID +
      '/users',
    method: 'POST',
    data: params
  });
}

/**
 * 组织机构
 */

// 获取组织机构结构
export function getOrgStructureApi(params) {
  return request({
    url: '/enterprise-server/enterprises/' + params.eid + '/organizations',
    method: 'GET',
    params: params
  });
}

// 新增组织
export function addOrgApi(params) {
  return request({
    url: '/enterprise-server/enterprises/' + params.eid + '/organizations',
    method: 'POST',
    data: params
  });
}

// 修改组织
export function modifyOrgApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/organizations/' +
      params.orgID,
    method: 'PUT',
    data: params
  });
}

// 删除组织
export function deleteOrgApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/organizations/' +
      params.orgID,
    method: 'DELETE',
    params: params
  });
}

// 获取组织下用户列表
export function getAllUserListApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/organizations/' +
      params.orgID +
      '/users',
    method: 'GET',
    params: params
  });
}

// 创建用户
export function addUserApi(params) {
  return request({
    url: '/enterprise-server/enterprises/' + params.eid + '/users',
    method: 'POST',
    data: params
  });
}

export function getEnterpriseUsersApi(params) {
  return request({
    url: '/enterprise-server/enterprises/' + params.eid + '/users',
    method: 'GET'
  });
}

// 修改用户
export function modifyUserApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/users/' +
      params.userID +
      '/userinfo',
    method: 'PUT',
    data: params
  });
}
// 组织机构--编辑用户
export function modifyUsersApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/users/' +
      params.userID,
    method: 'PUT',
    data: params
  });
}
// 删除用户
export function deleteUserApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/users/' +
      params.userID,
    method: 'DELETE',
    params: params
  });
}

// 修改密码
export function modifyUserPwdApi(params) {
  return request({
    url:
      '/enterprise-server/enterprises/' +
      params.eid +
      '/users/' +
      params.userID +
      '/password',
    method: 'PUT',
    data: params
  });
}

export function fetchAccessToken(param) {
  return request({
    url: `/enterprise-server/enterprises/${param.eid}/accesskeys`,
    method: 'GET',
    params: param
  });
}

export function addAccessKeyApi(param) {
  return request({
    url: `/enterprise-server/enterprises/${param.eid}/accesskeys`,
    method: 'post',
    data: param
  });
}

export function updateAccessKeyApi(param) {
  return request({
    url: `/enterprise-server/enterprises/${param.eid}/accesskeys/${param.accessKeyID}/re-generate`,
    method: 'post',
    data: {}
  });
}

export function deleteAccessKeyApi(param) {
  return request({
    url: `/enterprise-server/enterprises/${param.eid}/accesskeys/${param.accessKeyID}`,
    method: 'delete'
  });
}

export function updateEnterprise(param) {
  return request({
    url: `/enterprise-server/enterprises/${param.eid}`,
    method: 'PUT',
    data: param
  });
}

export function verifyEnterprise(param) {
  return request({
    url: `/enterprise-server/enterprises/${param.eid}/verify`,
    method: 'POST',
    data: param
  });
}

export function fetchEnterpriseVerifyInfo(eid) {
  return request({
    url: `/enterprise-server/enterprises/${eid}/verify`,
    method: 'get'
  });
}



// WEBPACK FOOTER //
// ./src/api/enterpriseManage.js